import { Form, FormTextInput, PasswordInput } from 'ck-components';
import { PostLoginRequestV1, useAuth } from 'ck-queries';
import { SubmitHandler, useForm } from 'react-hook-form';

/**
 * The form which handles the login information.
 *
 */

export function LoginForm() {
  const form = useForm<PostLoginRequestV1>();
  const { handleSubmit } = form;
  const { M_login } = useAuth();

  const onSubmit: SubmitHandler<PostLoginRequestV1> = (data) =>
    M_login.mutate(data);

  return (
    <Form
      onSubmit={handleSubmit(onSubmit)}
      submitButtonLabel='Logga in'
      className='gap-2'
      submitButtonStyle='w-full'
      form={form}
      isSubmitting={M_login.isLoading}
    >
      <FormTextInput
        name='email'
        label='E-postadress'
        parentForm={form}
        errorsAlwaysTakeUpSpace={false}
        options={{
          pattern: {
            value:
              // eslint-disable-next-line no-useless-escape
              /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
            message: 'Det måste vara en giltig e-postadress',
          },
        }}
      />

      <PasswordInput
        name='password'
        label='Lösenord'
        parentForm={form}
        minLength={6}
      />
    </Form>
  );
}
